// libraries
import React from "react";

// styles
import styles from "./styles.module.scss";

const Radio = (props) => {
  return (
    <label className={styles.radio}>
      <input type='checkbox' {...props} /> I agree to the&nbsp;
      <a href='/terms&conditions' target='_blank'>
        {" "}
        terms and conditions.
      </a>
    </label>
  );
};

export default Radio;
